export default __webpack_public_path__ + "static/media/image.atrad.00d50790.png";